import Vue from "vue";

/**
 * A wrapper function to track custom events in GA. For more
 * info on what these params mean, please consult the official
 * Google documentation:
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 * @param {object} eventData An object containing the category, action, label, value, and AB exp data. Only the first two are mandatory.
 */
export const trackEvent = (eventData) => {
	if (
		typeof window.__PRERENDER_INJECTED !== "undefined" ||
		typeof window.__TEST__ !== "undefined"
	)
		return false;
	if (typeof Vue.$ga !== "object" || typeof Vue.$ga.event !== "function")
		return false;

	// The GA tracking requires at least the category and the action of the event.
	if (!eventData.eventCategory || !eventData.eventAction) return false;

	Vue.$ga.event(eventData);
};

/**
 * Google Analytics Trackers
 */
export const trackers = () => {
	let output = {
		YD: "UA-16913401-21",
		WF: "UA-16913401-22",
		WF_ONLY: "UA-209673812-1", // new one
		WF_ALL_PRODUCTS: "UA-209673812-3", // new one
		SanityCheck: "UA-16913401-1",
	};

	/**
	 * YD and WF trackers are sampled to 1% and 5% respectively (See
	 * TRACKER_SETTINGS in common/consts). That's why we have a SanityCheck
	 * tracker without any sampling (tracks 100% of hits).
	 *
	 * By PM requirement, this sanity check is only performed the 13th of
	 * each month.
	 */
	if (new Date().getUTCDate() !== 13) {
		delete output.SanityCheck;
	}

	return output;
};
